import type { RedoMarketplaceRpcClient } from "@redotech/marketplace-sdk/rpc/client";
import { createRedoMarketplaceRpcClient } from "@redotech/marketplace-sdk/rpc/client";
import { Context, createContext, ReactNode, useMemo } from "react";

export const RedoMarketplaceRpcClientContext: Context<
  RedoMarketplaceRpcClient | undefined
> = createContext<RedoMarketplaceRpcClient | undefined>(undefined);
RedoMarketplaceRpcClientContext.displayName = "RedoMarketplaceRpcClientContext";

export function RedoMarketplaceRpcClientProvider({
  children,
  baseUrl,
  authToken,
}: {
  children: ReactNode | ReactNode[];
  baseUrl: string;
  authToken?: string;
}) {
  const redoMarketplaceRpcClient = useMemo(() => {
    return createRedoMarketplaceRpcClient({
      baseURL: new URL(`${baseUrl}/rpc`),
      headers: authToken ? { Authorization: authToken } : {},
    });
  }, [baseUrl, authToken]);
  return (
    <RedoMarketplaceRpcClientContext.Provider value={redoMarketplaceRpcClient}>
      {children}
    </RedoMarketplaceRpcClientContext.Provider>
  );
}
